import { mockAPI } from "./mockApi";
import { backendAPI } from "./backendAPI";

const USE_MOCK = process.env.REACT_APP_USE_MOCK_API !== "false";

export const api = USE_MOCK ? mockAPI : backendAPI;
